import {  ExpandCircleDown, Close } from "@mui/icons-material";
import { Box, Dialog, FormControlLabel, IconButton, TextField, Button, Grid, Typography, DialogTitle, DialogContent, DialogActions, DialogContentText, Checkbox, Paper, makeStyles } from "@mui/material";
import { useEffect, useState } from "react";
import { DataAttribute, DataField } from "../../data/interfaces/sharedmodels";

export default function MergeGroupField({title , mergeFields,values,  uniqueIdValue, callback }: 
  {title:string,  mergeFields: DataField[],values: (DataAttribute | undefined)[], uniqueIdValue: string, callback: any}) {

    const [openDialog, setOpenDialog] = useState(false);
    const [currentValues, setCurrentValues] = useState(values);
   const [combinedValue,setCombinedValue]= useState("");

   useEffect(() => {
    setCombinedValue(currentValues.map(item => item?.Value ? '1' : '0').join(''));
},[currentValues])


  
    const FieldExpandDialog=()=>{
        
        return(
           
    
    <Dialog open={openDialog} onClose={handleCloseDialog}>
  <DialogTitle sx={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '16px', marginBottom: '16px' }}>
    <Grid container alignItems="center" justifyContent="space-between">
      <Grid item >
      <Grid container alignItems="center" >
      <Grid item >
      <Typography variant="h6">{title}:</Typography>
      </Grid>
      <Grid item >
      <TextField size="small" disabled value={combinedValue}/>
      </Grid>   
        </Grid>
        
      </Grid>
     
      <Grid item >
        <IconButton onClick={handleCloseDialog}>
          <Close />
        </IconButton>
      </Grid>
    </Grid>
  </DialogTitle>
  <DialogContent sx={{ paddingTop: '16px' }}>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {mergeFields.map((field: DataField, index: number) => (
          <FormControlLabel
            key={index}
            label={field.Description}
            control={
              <Checkbox
                checked={currentValues[index]?.Value}
                onChange={() => handleCheckboxChange(index)}
              />
            }
          />
        ))}
      </Grid>
    </Grid>
  </DialogContent>
  <Paper>
    <DialogActions sx={{ borderTop: '2px solid #e0e0e0', paddingTop: '16px', paddingBottom: '16px', paddingLeft:'30px',paddingRight:'30px',justifyContent: 'space-between'  }}>
      <Button size="small" variant="outlined" color="primary" onClick={handleCancel}>
        Cancel
      </Button>
      <Button size="small" variant="contained" color="primary" onClick={handleSave}>
        Submit
      </Button>
    </DialogActions>
    </Paper>
</Dialog>
    

        )
    }

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleSave = () => {
        if (currentValues !== values) {
            mergeFields.forEach((field, index) => {
                const newValue = currentValues[index]?.Value ?? false;
                callback(field,uniqueIdValue , newValue);
            });
        }
        handleCloseDialog();
    };

    const handleCancel = () => {
        handleCloseDialog();
    };

    const handleCheckboxChange = (index: number) => {
        const updatedValues = [...currentValues]; 
        updatedValues[index] = {
            ...updatedValues[index] as DataAttribute  , 
            Value: !updatedValues[index]?.Value 
        };
        setCurrentValues(updatedValues); 
    };
    return (
        <Box>
            <TextField
                disabled
                size="small"
                sx={{ minWidth: 400 }}
                InputProps={{
                    endAdornment: <IconButton onClick={handleOpenDialog}>
                        <ExpandCircleDown />
                    </IconButton>
                }}
                value={combinedValue} />

                <FieldExpandDialog></FieldExpandDialog>
        </Box>
    );
}
